/**
 * Koostöövorm — the form of the working relationship, stored on
 * portal_employment_records.collaboration_type. Stable keys; display labels
 * live in i18n (t.portal.profile.collaborationTypes).
 */
export const COLLABORATION_TYPES = [
    'employment_full_time',
    'employment_part_time',
    'employment_flex',
    'intern',
    'board_member',
    'partner',
] as const

export type CollaborationType = (typeof COLLABORATION_TYPES)[number]

export const isCollaborationType = (value: unknown): value is CollaborationType =>
    typeof value === 'string' && (COLLABORATION_TYPES as readonly string[]).includes(value)

/**
 * Collaboration forms that draw a payroll/wage from the company and therefore
 * belong in the monthly payroll-info report (Palgainfo raport, TASK-175):
 * employees and interns. Board members and partners are paid differently and
 * are excluded.
 */
export const PAYROLL_COLLABORATION_TYPES = [
    'employment_full_time',
    'employment_part_time',
    'employment_flex',
    'intern',
] as const satisfies readonly CollaborationType[]

/**
 * Collaboration forms that count as employees proper — an employment contract
 * (Tööleping): full-time, part-time, or FLEX. Board members, partners, and
 * interns are excluded. Used by the average-tenure dashboard card (TASK-350).
 */
export const EMPLOYEE_COLLABORATION_TYPES = [
    'employment_full_time',
    'employment_part_time',
    'employment_flex',
] as const satisfies readonly CollaborationType[]
